// src/api/sale/saleInvalidationApi.ts
import apiHandler from "../core/apiHandler";

const saleInvalidationApi = apiHandler('sales/invalidation');

export default saleInvalidationApi;
